module.exports = __webpack_public_path__ + "img/20211013_1.fd5ec5ed.jpg";